import styles from './SidesItem.module.css';
import { BlueBtn } from '../../UI/BlueBtn/BlueBtn.jsx';
import trashIcon from '../../assets/trash-icon.svg';

export const SidesItem = ({ item, onDelete, from, itemType }) => {
	if (!item) return null;

	const itemTypePrice = `${itemType}_price`;
	const itemTypePriceDisc = `${itemType}_price_disc`;

	const price = item.price || item[itemTypePrice] || 0;
	const discountPrice = item.price_disc || item[itemTypePriceDisc] || null;
	const subTime = item.time || '';

	return (
		<div className={styles.main}>
			<img className={styles.itemImg} src={item.img} alt="itemImg" />
			<div className={styles.right_block}>
				<h3>{item.title}</h3>
				<p>{item?.editionTitle && item.editionTitle}</p>
				{
					discountPrice &&
					<span className={styles.price_amount}>{price}</span>
				}
				<h2 style={discountPrice ? {color: 'red'} : {}}>{discountPrice ? `${discountPrice} ₽` : `${price} ₽`}</h2>
				{subTime && (
					<p className={styles.subTime}>{subTime}-месячная подписка</p>
				)}
				{itemType && <p>{itemType}</p>}
				<div className={styles.buttons}>
					<BlueBtn
						type={`in${from}`}
						style={{ paddingTop: 12, paddingBottom: 12}}
						subscriptionId={item.time && item.id}
						itemId={item.time || item.edition ? undefined : item.id}
						editionId={item.edition && item.id}
					/>
					<div className={styles.delBtn} onClick={onDelete}>
						<img src={trashIcon} alt="trashIcon" />
					</div>
				</div>
			</div>
		</div>
	);
};
